import type { ConsoleErrorI18nReactProps } from "@i18n/react/src/utils";

export const consoleErrorI18nNext = ({
  error,
  heading,
}: ConsoleErrorI18nReactProps) =>
  console.error(`[@i18n/next] ${heading}:\n\t${error}`);
